import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import Image from '@jetshop/ui/Image/Image';
import React from 'react';
import { styled } from 'linaria/react';

import { theme } from '../Theme';

export const CategoryHeaderWrapper = styled('div')`
  width: 100%;
  display: block;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${theme.below.xl} {
    max-width: 100%;
    width: 100%;
    padding: 0px;
  }
`;

const CategoryImageWrapper = styled('div')`
  height: 320px;
  width: 100%;
  ${theme.below.lg} {
    height: 217px;
  }
`;

export const NoImageWrapper = styled('div')`
  margin-top: 3.5rem;
  padding: 10px;
`;

const CategoryName = styled('h1')`
  font-weight: 600;
  line-height: normal;
  font-size: 2rem;
  margin-bottom: 10px;
  ${theme.below.lg} {
    font-size: 1.5rem;
  }
`;

const CategoryContent = styled('div')`
  font-weight: 300;
  line-height: 26px;
  font-size: 14px;
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 8px;
  justify-content: center;
  padding-top: 30px;
`;

const HeaderImage = styled(Image)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  ${StyledBreadcrumbs} {
    a,
    li {
      color: white;
    }
  }
`;

export const Inner = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 700px;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 20px;

  &.category-content {
    margin-top: 0;
    max-width: 100%;
  }

  .html-content {
    margin: 0;
    display: block;
    width: 100%;

    .breadcrumbs-title-wrapper {
      display: block;
      width: 100%;
      clear: both;
    }

    .category-title {
    }
    .breadcrumbs {
    }
  }

  &.info-content {
    max-width: 900px;
    text-align: left;
    justify-content: flex-start;
    padding: 0 20px;
    .category-content-wrapper {
      max-width: 100%;
      font-size: 14px;
      line-height: 1.6;
      margin-top: 2rem;

      p {
        margin-bottom: 1.5rem;
      }

      h2 {
        font-size: 2rem;
      }
      h3 {
        font-size: 1rem;
      }
      h4 {
        font-size: 1rem;
      }
      strong {
        font-weight: bold;
      }
    }
  }
`;

const Content = ({ category, breadcrumbProps }) => (
  <Inner
    className={
      category?.parent?.id === 166 ? 'info-content' : 'category-content'
    }
  >
    {category?.content?.length > 0 && category.content.indexOf('<div') > -1 ? (
      <div className="html-content">
        <CategoryContent
          className="category-content-wrapper"
          data-testid="category-description"
          dangerouslySetInnerHTML={{
            __html: category.content
          }}
        />
        <div className="breadcrumbs-title-wrapper">
          <div className="breadcrumbs">
            <StyledBreadcrumbs {...breadcrumbProps} />
          </div>
          <div className="category-title">
            <CategoryName data-testid="page-header">
              {category.name}
            </CategoryName>
          </div>
        </div>
      </div>
    ) : (
      <>
        <StyledBreadcrumbs {...breadcrumbProps} />
        <CategoryName data-testid="page-header">{category.name}</CategoryName>
        <CategoryContent
          className="category-content-wrapper"
          data-testid="category-description"
          dangerouslySetInnerHTML={{
            __html: category.content
          }}
        />
      </>
    )}
  </Inner>
);

const CategoryHeader = ({ category, parents }) => {
  const breadcrumbProps = {
    breadcrumbs: category?.primaryRoute?.breadcrumbs,
    parents
  };
  const isImageBackground = category.images && category.images.length > 0;
  return (
    <CategoryHeaderWrapper>
      {isImageBackground ? (
        <CategoryImageWrapper>
          <HeaderImage
            src={category.images}
            fillAvailableSpace
            cover
            quality={80}
          ></HeaderImage>
        </CategoryImageWrapper>
      ) : null}
      <Content category={category} breadcrumbProps={breadcrumbProps} />
    </CategoryHeaderWrapper>
  );
};

export default CategoryHeader;
